import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPagespeedinsightsComponent } from './simple-icons-pagespeedinsights.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPagespeedinsightsComponent ],
    exports:      [ SimpleIconsPagespeedinsightsComponent ],
    bootstrap:    []
})
export class SimpleIconsPagespeedinsightsModule {}
